<div [attr.id]="editorViewerPortID" class="editor-view-port">
  <div [attr.id]="zoomWrapperID" class="zoom-wrapper" [ngClass]="'zoomLevel-' + zoomLevel">
    <!-- This graph wrapper is where all of the node components are created in -->
    <div [attr.id]="graphViewerWrapperID" class="graph-viewer-wrapper">
      <!-- This svg container is what is used to draw the lines -->
      <svg [attr.id]="graSVGContainerID" class="graph-svg-container" #svgContainer></svg>
      <div [attr.id]="graphNodeViewerID" class="graph-node-viewer" #nodeViewer></div>
    </div>
  </div>
</div>

<svg id="background-pattern" class="background-pattern">
  <pattern
    id="pattern-circles"
    x="0"
    y="0"
    width="20"
    height="20"
    patternUnits="userSpaceOnUse"
    [ngClass]="'zoomLevel-' + zoomLevel"
  >
    <circle cx="1" cy="1" r="2" class="circle"></circle>
  </pattern>
  <rect id="rect" x="0" y="0" width="100%" height="100%" fill="url(#pattern-circles)"></rect>
</svg>

<automata-zoom-control
  *ngIf="!readOnly"
  (zoomLevel)="zoomLevel = $event"
  (centerToTrigger)="centerMySelfToTrigger()"
  [maxZoom]="10"
  [minZoom]="1"
  [newView]="true"
></automata-zoom-control>
